<template>
  <div class='SelectBanner'>
    <div class="select">
      <input-reg
      :value="link"
      @update:model-value="newValue => link = newValue"
      :cont="{ textAlign: 'left', width: '80%' }"
      :label="{ marginLeft: '3px', display: 'none' }"
      :input="{ fontSize: '16px', padding: '2.5%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      placeholder="Link"
      />
      <div class="cont-btn">
        <button @click="Push">adicionar</button>
      </div>
    </div>
    <div class="cont">
      <banner-list
      v-for="(b, key) in Banners"
      :key="key"
      :data="b"
      @del="id => Del(id)"
      @updateimg="newValue => b.img = newValue"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BannerList from './BannerList'
import InputReg from '../Produtos/Register/InputReg'
export default {
  name: 'SelectBanner',
  components: { BannerList, InputReg },
  data () {
    return {
      link: '',
      Banners: []
    }
  },
  computed: {
    ...mapGetters(['Categorias'])
  },
  methods: {
    ...mapActions(['_CreateBannerImg', '_DeleteBannerImg', 'GetBannerImg']),
    Push () {
      this._CreateBannerImg({ img: '', link: this.link })
        .then(res => {
          this.Banners.push(res)
          this.link = ''
        })
    },
    Del (id) {
      this._DeleteBannerImg({ id: id })
        .then(() => {
          this.Banners = this.Banners.filter(i => i.id !== id)
        })
    }
  },
  created () {
    this.GetBannerImg()
      .then(res => {
        this.Banners = res
      })
  }
}
</script>

<style scoped>

.select {
  display: flex;
  justify-content: start;
  align-items: center;
}

.cont-btn {
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: end;
  padding: 2%;
}

button {
  color: #FFFFFF;
  padding: 8%;
  background-color: #000000;
  border: 0;
  border-radius: 5px;
  cursor: pointer;
}

</style>
